module.exports = __webpack_public_path__ + "img/icon_goumaili_duihuan.fc046d97.png";